// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth, GoogleAuthProvider} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA-LC7zI5_ckFBiQgC5oCDyvCdwhBQFYEs",
  authDomain: "react-course-project-social.firebaseapp.com",
  projectId: "react-course-project-social",
  storageBucket: "react-course-project-social.appspot.com",
  messagingSenderId: "388060094997",
  appId: "1:388060094997:web:96323e42b2e186e663a41c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);